"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputRadioButton = exports.RadioButtonIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconConst = require("./icons/iconConst");

var _FieldRadio = require("./microFields/FieldRadio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RadioButtonIcon = function RadioButtonIcon(_ref) {
  var isChecked = _ref.isChecked;
  var icon = isChecked ? _iconConst.CHECK_SELECTED : _iconConst.CIRCLE_EMPTY_ICON;
  var containerProps = {
    className: 'radio-icon'
  };
  return _react.default.createElement("div", containerProps, icon);
};

exports.RadioButtonIcon = RadioButtonIcon;
RadioButtonIcon.defaultProps = {
  isChecked: false
};
RadioButtonIcon.propTypes = {
  isChecked: _propTypes.default.bool
};
/* these will be styled as input radio button-ish things globally */

/* no passing classes */

var InputRadioButton = function InputRadioButton(_ref2) {
  var children = _ref2.children,
      name = _ref2.name,
      val = _ref2.val,
      isChecked = _ref2.isChecked,
      handleChange = _ref2.handleChange,
      doFocus = _ref2.doFocus;
  var buttonProps = {
    children: children,
    name: name,
    val: val,
    cssClass: 'radio-button',
    doFocus: doFocus,
    handleChange: handleChange
  };
  return _react.default.createElement(_FieldRadio.FieldRadio, buttonProps, _react.default.createElement(RadioButtonIcon, {
    isChecked: isChecked
  }), children);
};

exports.InputRadioButton = InputRadioButton;
InputRadioButton.defaultProps = {
  doFocus: false
};
InputRadioButton.propTypes = _objectSpread({}, _FieldRadio.radioPropTypes, {
  doFocus: _propTypes.default.bool
});